export var OperatorType;
(function (OperatorType) {
    OperatorType["or"] = "or";
})(OperatorType || (OperatorType = {}));
export var Comparator;
(function (Comparator) {
    Comparator["is"] = "is";
    Comparator["isNot"] = "isNot";
})(Comparator || (Comparator = {}));
export var OutcomeType;
(function (OutcomeType) {
    OutcomeType["show"] = "show";
    OutcomeType["options"] = "options";
})(OutcomeType || (OutcomeType = {}));
export const isOperand = (condition) => {
    return 'field' in condition && 'matcher' in condition;
};
export const isShowOutcome = (condition) => {
    return condition.type === OutcomeType.show;
};
export const isOptionsOutcome = (condition) => {
    return condition.type === OutcomeType.options;
};
export const isSelectElement = (element) => element.type === 'select';
